import { apiFetch } from "../client"

export interface CompletedReviewRow {
  clientId: string
  fullName: string
  phoneNumber: string
  reviewerId: string | null
  reviewerName: string | null
  decision: string
  rejectionReason: string | null
  checklist: Array<{ item: string; passed: boolean; note?: string }> | null
  reviewedAt: string | null
  reviewDurationSeconds: number | null
  createdAt: string
}

export interface ReviewerProductivitySummary {
  reviewerId: string
  reviewerName: string
  totalReviews: number
  approvedCount: number
  rejectedCount: number
  rejectionRate: number
  averageReviewTimeSeconds: number | null
  lastActiveAt: string | null
}

export interface OwnReviewerProductivity {
  totalReviews: number
  approvedCount: number
  rejectedCount: number
  approvalRate: number
  averageReviewTimeSeconds: number | null
  reviewsThisWeek: number
  reviewsThisMonth: number
}

export async function listKycQueue(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/kyc/queue${query}`)
}

export async function getKycReviewDetail(clientId: string) {
  return apiFetch<any>(`/kyc/queue/${clientId}`)
}

export function getKycDocumentUrl(clientId: string, documentId: string): string {
  const token = localStorage.getItem("session_token") ?? ""
  return `/api/v1/kyc/queue/${clientId}/documents/${documentId}?token=${encodeURIComponent(token)}`
}

export async function submitKycReview(clientId: string, payload: Record<string, unknown>) {
  return apiFetch<any>(`/kyc/queue/${clientId}/review`, {
    method: "POST",
    rawBody: payload,
  })
}

export async function requestMoreKycInfo(clientId: string, payload: Record<string, unknown>) {
  return apiFetch<any>(`/kyc/queue/${clientId}/request-more-info`, {
    method: "POST",
    rawBody: payload,
  })
}

export async function listCompletedReviews(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<{
    data: CompletedReviewRow[]
    meta: {
      page: number
      perPage: number
      totalItems: number
      totalPages: number
    }
  }>(`/kyc/completed${query}`)
}

export async function getReviewerProductivity() {
  return apiFetch<{ data: { reviewers: ReviewerProductivitySummary[] } }>("/kyc/productivity")
}

export async function getMyReviewerProductivity() {
  return apiFetch<{ data: OwnReviewerProductivity }>("/kyc/productivity/me")
}
